<template>
    <div>
      <vs-prompt
      @cancel="canceld"
      @accept="accepted"
      @close="closed"
      :active.sync="dlgActive"
      :title="popupTitle"
      :accept-text="$t('COM.SAVE')"
      :cancel-text="$t('COM.CANCEL')"
      id="promptAddNewsletterReclist"
      :is-valid="formValid">
       <div>
          <div>
            <p>{{$t('NEWSLETTER.ADD_NEWSLETTER_RECL.HEADER.TEXT')}}</p>
            <div class="default-input clearfix align-items-center mb-3">
              <vs-input :label="$t('NEWSLETTER.ADD_NEWSLETTER_RECL.NAME')"  class="mr-3 inputx" :placeholder="$t('NEWSLETTER.PLACEHOLDER.ADD_NEWSLETTER_RECL.NAME')"  v-model="data.name" :danger="name_fail" val-icon-danger="clear"/>
            </div>   
            <vs-divider>{{$t('NEWSLETTER.DIVIDER.MEMBER_ADD')}}</vs-divider>      
            <div class="default-input clearfix align-items-center mb-3">
                <vs-select :label="$t('NEWSLETTER.LABEL.RECMEM_USERFK')" v-model="memUserFk" class="float-left inputx mr-3">
                   <div :key="index" v-for="(item,index) in recmemUsers">
                      <vs-select-group :title="item.title" v-if="item.group">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in item.group"/>
                      </vs-select-group>
                    </div>

                </vs-select>
                <vs-input :disabled="memUserFk > 0" :label="$t('NEWSLETTER.ADD_NEWSLETTER_RECL_MEM.NAME')"  class="float-left inputx mr-3" :placeholder="$t('NEWSLETTER.PLACEHOLDER.ADD_NEWSLETTER_RECLMEM.NAME')"  v-model="memName" />
                <vs-input :disabled="memUserFk > 0" :label="$t('NEWSLETTER.ADD_NEWSLETTER_RECL_MEM.EMAIL')"  class="inputx float-left  mr-3" :placeholder="$t('NEWSLETTER.PLACEHOLDER.ADD_NEWSLETTER_RECLMEM.EMAIL')"  v-model="memEmail" />
                <vs-button :disabled="!IsAddAllowed" class="inputx float-left" @click="AddMemberToList">+</vs-button>
            </div>
            <vs-divider>{{$t('NEWSLETTER.DIVIDER.MEMBER')}}</vs-divider>

            <div class="default-input clearfix align-items-center mb-3">
              <div  class="float-left mr-2">
                <div id="reclist_table" class="vs-con-loading__container" >
                  <vs-table
                    :data="data.member"
                    :noDataText="$t('NEWSLETTER.NO_DATA')"
                    stripe
                    max-items="25" 
                    pagination
                    hoverFlat>

                    <template slot="header">
                      <h3>
                        {{$t('NEWSLETTER.RECLIST_MEM.TABLE.HEADER')}}
                      </h3>
                    </template>
                    <template slot="thead">                               
                      <vs-th sort-key="name">
                        {{$t('NEWSLETTER.RECLIST_MEM.TABLE.COL1')}}
                      </vs-th>
                      <vs-th sort-key="email">
                        {{$t('NEWSLETTER.RECLIST_MEM.TABLE.COL2')}}
                      </vs-th>                                                                                                          
                      <vs-th></vs-th>                                                                                                                                             
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                        <vs-td :data="tr.name">
                          {{tr.name}}
                        </vs-td>                  
                        <vs-td :data="tr.email">
                          {{tr.email}}
                        </vs-td>                                                                                                    
                        <vs-td>
                          <vs-button  @click="RemoveMember(tr.id)" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                        </vs-td>                    
                                                                                                                                                                                                  
                      </vs-tr>
                    </template>
                  </vs-table>
                </div> 
              </div>
            </div>   
          </div>

       </div>
     </vs-prompt>
    </div>
</template>
<script>

import helperMethods from '../../../helper/staticFuncHelper';
import codeHelper from '../../../helper/staticCodeHelper';
import enumHelper from '../../../helper/enumHelper';


export default {
  name: "AddNewsletterReclistDlg",
  props:[],
  components:{
      
  },
  data: function (){
     return {
      dlgActive:false,
      popupTitle:this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.TITLE'),
      name_fail:false,
      name_ok:false, 
      data:this.GetEmptyData(),
      memName:"",
      memEmail:"",
      memUserFk:0,
      possibleMem:[]
     }
  }, 
  mounted () {
    this.ClearForm();
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      ShowDlg(){
        this.ClearForm();
        this.dlgActive=true;
        this.popupTitle = this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.TITLE');
        
      },
      closed(){
        this.ClearForm();
      },
      InitDlgData(data){
        
        if(this.IsNotNull(data))
        {
          this.ClearForm();
          this.popupTitle = this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.TITLE.EDIT');
          
          this.data = JSON.parse(JSON.stringify(data));

          this.dlgActive=true;
        }
      },      
      accepted(){

          this.$store.dispatch('newsletter/saveReclist', this.data)
          .then(response => {
            if(response.success === true)
            {
                this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.SUCCESS.SAVE')});  
                this.$emit('Success',response.id);
            }
            else
            {
              var text = this.$t(response.text);
              this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.WARNING.SAVE').replace("*1*",text)}); 
            }
            
          }, 
          error =>{
              this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('NEWSLETTER.ADD_NEWSLETTER_RECL.ERROR.SAVE').replace("*1*",error)});  
          });

          this.ClearForm();
      },
      canceld(){
        this.ClearForm();
      },
      ClearForm(){ 
        this.data=this.GetEmptyData();
      },
      GetEmptyData(){
        return {
          id:0,
          name:"",
          member:[],
          company_fk:0
        };
      },
      AddMemberToList(){
        let mem = {name: this.memName, email: this.memEmail, user_fk: this.memUserFk, id:0};
        this.data.member.push(mem);
        this.memEmail = "";
        this.memName = "";
        this.memUserFk = 0;
      },
      RemoveMember(id){
        for(var i =0; i < this.data.member.length;i++)
        {
            if(this.data.member[i].id == id)
            {
                this.data.member.splice(i,1);
                break;
            }
        }
      }
  },
  computed:{
    formValid(){
      return this.data.name.length > 0;
    },

    recmemUsers(){
      var ret = [];
      ret.push({
          title:'Keine Auswahl',
          group:[
            {text: '-----', value: 0}
          ]
        });

      if(this.$store.state.newsletter.recuserdata.data != null)
      {
        for (let i = 0; i < this.$store.state.newsletter.recuserdata.data.length; i++) {
          let element = this.$store.state.newsletter.recuserdata.data[i];

          let entry = {title:element.name, group:[]};
          element.member.forEach(grp_ele => {
            entry.group.push({"text": grp_ele.lastname + ', ' + grp_ele.firstname, "value":grp_ele.user_fk});  
          });
          ret.push(entry);
        }
      }
      return ret;
    },
    IsAddAllowed(){
      return this.memUserFk > 0 || (this.memEmail.length > 0 && this.memName.length > 0);
    }
  },
  watch:{
    memUserFk(value)
    {
      if(value > 0)
      {
        if(this.$store.state.newsletter.recuserdata.data != null)
        {
          for (let i = 0; i < this.$store.state.newsletter.recuserdata.data.length; i++) {
            let element = this.$store.state.newsletter.recuserdata.data[i];

            for (let j = 0; j < element.member.length; j++) {
              let user = element.member[j];
              if(user.user_fk == value)
              {
                this.memEmail = user.email;
                this.memName = user.firstname + " " + user.lastname;
                break;
              }
            }
          }
        }
      }
      else
      {
        this.memEmail = ""
        this.memName = "";
      }
    }
  }
};
</script>
<style>
div#promptAddNewsletterReclist > div.vs-dialog{
  max-width: 800px !important;
}

</style>